import React, { useEffect, useState } from "react";
import api from "@/services/api.js";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

const AvatarComponent = ({ userId, username, className = "w-9 h-9" }) => {
  const [avatarUrl, setAvatarUrl] = useState(null);

  useEffect(() => {
    if (!userId) return;

    const fetchAvatar = async () => {
      try {
        const res = await api.get(`/users/avatar/${userId}`, {
          responseType: "blob",
        });
        const url = URL.createObjectURL(res.data);
        setAvatarUrl((old) => {
          if (old) URL.revokeObjectURL(old);
          return url;
        });
      } catch {
        /* no avatar set */
      }
    };
    fetchAvatar();
  }, [userId]);

  return (
    <Avatar className="w-9 h-9">
      <AvatarImage src={avatarUrl ?? undefined} />
      <AvatarFallback className={"bg-violet-500/20 text-violet-300 text-2xl font-bold"}>
        {username?.[0]?.toUpperCase()}
      </AvatarFallback>
    </Avatar>
  );

  //   if (avatarUrl) {
  //     return (
  //       <img
  //         src={avatarUrl}
  //         alt={username}
  //         className={`${className} rounded-full object-cover`}
  //       />
  //     );
  //   }

  //   return (
  //     <div
  //       className={`${className} rounded-full bg-zinc-700 flex items-center justify-center text-zinc-300 text-sm font-medium`}
  //     >
  //       {username?.charAt(0).toUpperCase()}
  //     </div>
  //   );
};

export default AvatarComponent;
